import Routes from "./router/index";
function App() {
    return (
        <div className="App">
            <Routes />
        </div>
    );
}

export default App;
